import { render, staticRenderFns } from "./AdminOrgSelector.vue?vue&type=template&id=1146bf81&scoped=true"
import script from "./AdminOrgSelector.vue?vue&type=script&lang=js"
export * from "./AdminOrgSelector.vue?vue&type=script&lang=js"
import style0 from "./AdminOrgSelector.vue?vue&type=style&index=0&id=1146bf81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1146bf81",
  null
  
)

export default component.exports